import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ListItem } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Link from "@mui/material/Link";
import { useContext, useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { ConstantContext } from "components/context/ConstantProvider";
import { UserContext } from "components/context/UserProvider";
import { toQueryString } from "components/hooks/useQueryStringState";
import SearchDrawerButton from "components/ui/atoms/SearchDrawerButton";

const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 80px;
  margin-bottom: 80px;
`;
const StyledListItemText = styled(ListItemText)`
  .MuiTypography-root {
    font-size: ${({ theme }) => theme.fontSize.sm};
    font-weight: ${({ theme }) => theme.fontWeight[400]};
  }
`;
const StyledSubListItem = styled(ListItem)`
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: ${({ theme }) => theme.palette_custom.lightBlue};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight[400]};
`;
const StyledSubListItemText = styled(ListItemText)`
  .MuiTypography-root {
    font-weight: ${({ theme }) => theme.fontWeight[200]};
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;
const StyledSubDivider = styled(Divider)`
  margin-left: 16px;
  margin-right: 16px;
`;
const StyledCount = styled(Box)(
  ({ theme, iscount }) => `
  background-color: ${
    iscount ? theme.palette_custom.yellow : theme.palette_custom.white
  };
  font-weight: ${theme.fontWeight[600]};
  font-size: ${theme.fontSize.xs};
  color: ${theme.palette_custom.darkBlue};
  width: ${theme.fontSize.md};
  height: ${theme.fontSize.md};
  display: flex;
  align-items: center;
  justify-content: center;
`,
);
const StyledCollapse = styled(Collapse)`
  padding-left: 8px;
  padding-right: 8px;
`;
const StyledListItemButton = styled(ListItemButton)(({ isopen, theme }) => {
  return `
    background-color: ${isopen ? theme.palette_custom.lightGrey : "inherit"};
  `;
});

const LeftNavigation = ({ isMobile }) => {
  const theme = useTheme();
  const { user, countDeal, countSourcing } = useContext(UserContext);
  const [sourcingCommitteeMeeting, setSourcingCommitteeMeeting] = useState([]);
  const [dealCommitteeMeeting, setDealCommitteeMeeting] = useState([]);
  const { dealFlows } = useContext(ConstantContext);
  const [expanded, setExpanded] = useState(false);

  const handleOpen = (panel) => {
    setExpanded(expanded !== panel ? panel : false);
  };

  useEffect(() => {
    let tempDealMeeting = [];
    let tempSourcingMeeting = [];
    const dealsParams = (df) => ({
      displayMode: "COMMITTEE",
      filter: {
        deal_flow: df.id,
      },
      offset: 0,
    });
    const sourcingParams = (df) => ({
      displayMode: "COMMITTEE",
      filter: {
        deal_flow: df.id,
      },
      offset: 0,
    });
    dealFlows.map((dealFlow) => {
      tempDealMeeting.push({
        text: dealFlow.short_name,
        url: `/deal${toQueryString(dealsParams(dealFlow))}`,
      });
      tempSourcingMeeting.push({
        text: dealFlow.short_name,
        url: `/sourcing${toQueryString(sourcingParams(dealFlow))}`,
      });
    });
    setDealCommitteeMeeting(tempDealMeeting);
    setSourcingCommitteeMeeting(tempSourcingMeeting);
  }, []);

  return (
    <>
      <StyledList component="nav">
        <SearchDrawerButton isMobile={isMobile} />
        <StyledListItemButton
          onClick={() => handleOpen("deals")}
          isopen={expanded == "deals" ? "true" : undefined}
        >
          <StyledListItemText>Deal</StyledListItemText>
          {expanded == "deals" ? (
            <ExpandLessIcon fontSize={theme.fontSize.sm} />
          ) : (
            <ExpandMoreIcon fontSize={theme.fontSize.sm} />
          )}
        </StyledListItemButton>
        <StyledCollapse in={expanded == "deals"} timeout="auto" unmountOnExit>
          <List dense={true}>
            <StyledSubListItem>My deals</StyledSubListItem>
            <StyledSubDivider />
            <ListItemButton
              component={Link}
              to={{
                pathname: "/deal",
                search: toQueryString({
                  filter: {
                    investment_status: [1, 2],
                    owners: [user.id],
                  },
                  sort: { ordering: "-created_at" },
                }),
              }}
            >
              <StyledSubListItemText>Inbox/Committee</StyledSubListItemText>
              {countDeal?.INBOX_COMMITTEE !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countDeal?.INBOX_COMMITTEE}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/deal",
                search: toQueryString({
                  filter: {
                    investment_status: [3, 4, 5, 6, 7],
                    owners: [user.id],
                  },
                  sort: { ordering: "-created_at" },
                }),
              }}
            >
              <StyledSubListItemText>Active due dil</StyledSubListItemText>
              {countDeal?.ACTIVE_DUE_DILL !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }}>
                  {countDeal?.ACTIVE_DUE_DILL}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/deal",
                search: toQueryString({
                  filter: {
                    investment_status: [8],
                    owners: [user.id],
                  },
                  sort: { ordering: "-created_at" },
                }),
              }}
            >
              <StyledSubListItemText>To close</StyledSubListItemText>
              {countDeal?.TO_CLOSE !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countDeal?.TO_CLOSE}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/deal",
                search: toQueryString({
                  filter: {
                    investment_status: [11],
                    owners: [user.id],
                  },
                  sort: { ordering: "-created_at" },
                }),
              }}
            >
              <StyledSubListItemText>Investment</StyledSubListItemText>
              {countDeal?.INVESTMENT !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }}>
                  {countDeal?.INVESTMENT}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton key={`all_deals`} component={Link} to={"/deal"}>
              <StyledSubListItemText>All</StyledSubListItemText>
            </ListItemButton>
          </List>
          <List dense={true}>
            <StyledSubListItem>Dealflow Committee</StyledSubListItem>
            <StyledSubDivider />
            {dealCommitteeMeeting?.map((commitee_meeting, index) => {
              return (
                <ListItemButton
                  key={`${commitee_meeting.text}-${index}`}
                  component={Link}
                  to={commitee_meeting.url}
                >
                  <StyledSubListItemText>
                    {commitee_meeting.text}
                  </StyledSubListItemText>
                </ListItemButton>
              );
            })}
          </List>
        </StyledCollapse>
        <StyledListItemButton
          onClick={() => handleOpen("sourcings")}
          isopen={expanded == "sourcings" ? "true" : undefined}
        >
          <StyledListItemText>Sourcing</StyledListItemText>
          {expanded == "sourcings" ? (
            <ExpandLessIcon fontSize={theme.fontSize.sm} />
          ) : (
            <ExpandMoreIcon fontSize={theme.fontSize.sm} />
          )}
        </StyledListItemButton>
        <StyledCollapse
          in={expanded == "sourcings"}
          timeout="auto"
          unmountOnExit
        >
          <List dense={true}>
            <StyledSubListItem>My sourcings</StyledSubListItem>
            <StyledSubDivider />
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  filter: {
                    status: ["AUTO_NOT_STARTED"],
                    sourcing_owner: [user.id],
                  },
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>Not started (Auto)</StyledSubListItemText>
              {countSourcing?.AUTO_NOT_STARTED !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countSourcing?.AUTO_NOT_STARTED}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  filter: {
                    status: ["MANUAL_NOT_STARTED"],
                    sourcing_owner: [user.id],
                  },
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>
                Not started (Manual)
              </StyledSubListItemText>
              {countSourcing?.MANUAL_NOT_STARTED !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countSourcing?.MANUAL_NOT_STARTED}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  filter: {
                    status: ["AUTO_IN_PROGRESS"],
                    sourcing_owner: [user.id],
                  },
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>In progress (Auto)</StyledSubListItemText>

              {countSourcing?.AUTO_IN_PROGRESS !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countSourcing?.AUTO_IN_PROGRESS}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  filter: {
                    status: ["MANUAL_IN_PROGRESS"],
                    sourcing_owner: [user.id],
                  },
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>
                In progress (Manual)
              </StyledSubListItemText>
              {countSourcing?.MANUAL_IN_PROGRESS !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countSourcing?.MANUAL_IN_PROGRESS}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  filter: {
                    status: ["REMINDER"],
                    sourcing_owner: [user.id],
                  },
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>Reminder</StyledSubListItemText>
              {countSourcing?.REMINDER !== 0 && (
                <StyledCount sx={{ borderRadius: "50%" }} iscount="true">
                  {countSourcing?.REMINDER}
                </StyledCount>
              )}
            </ListItemButton>
            <ListItemButton
              component={Link}
              to={{
                pathname: "/sourcing",
                search: toQueryString({
                  sort: { ordering: "updated_at" },
                }),
              }}
            >
              <StyledSubListItemText>All</StyledSubListItemText>
            </ListItemButton>
          </List>
          <List dense={true}>
            <StyledSubListItem>Watchlist Committee</StyledSubListItem>
            <StyledSubDivider />
            {sourcingCommitteeMeeting?.map((commitee_meeting, index) => {
              return (
                <ListItemButton
                  key={`${commitee_meeting.text}-${index}`}
                  component={Link}
                  to={commitee_meeting.url}
                >
                  <StyledSubListItemText>
                    {commitee_meeting.text}
                  </StyledSubListItemText>
                </ListItemButton>
              );
            })}
          </List>
        </StyledCollapse>
        <ListItemButton component={Link} to="/company">
          <StyledListItemText>Company</StyledListItemText>
        </ListItemButton>
        <ListItemButton component={Link} to="/note">
          <StyledListItemText>Note</StyledListItemText>
        </ListItemButton>
        <ListItemButton component={Link} to="/people">
          <StyledListItemText>People</StyledListItemText>
        </ListItemButton>
      </StyledList>
    </>
  );
};

export default LeftNavigation;
